import { Variant2 } from '@/@types/global';
import { VariantChangedEvent } from '@/@types/shopify';
import PackOptions from '@/components/pack-options';
import { defer } from '@/components/utils/defer';
import { createLogger } from '@/lib/logger';

const log = createLogger('pack-options');

const checkEligibility = (variantId: number) => {
  const variant = window.PDP.variants.find((v: Variant2) => v.id === variantId);

  if (!variant) {
    log.error('Could not find variant!');
    return false;
  }

  const priceDollars = variant.price / 100;

  const baseCurrencyPrice = window.Currency?.convert(
    priceDollars,
    window.Shopify.currency.active,
    window.theme.shopCurrency,
  ) ?? priceDollars;

  log.debug(`Raw price: $${priceDollars}`);
  log.debug(`Base currency price: $${baseCurrencyPrice}`);

  const eligible = baseCurrencyPrice >= window.theme.gift_product.price_threshold;

  log.debug(`Eligible: ${eligible}`);

  return eligible;
};

document.addEventListener('DOMContentLoaded', function () {
  function updateATCQty(qty: number) {
    const productForm = document.querySelector('form.ProductForm') as HTMLFormElement;

    if (!productForm) {
      log.error('Could not find product form!');
      return;
    }

    const atcButton = productForm.querySelector('button.ProductForm__AddToCart');

    if (!atcButton) {
      log.error('Could not find ATC button!');
      return;
    }

    atcButton.setAttribute('data-qty', qty.toString());
  }

  function updateSubscriptionOptions(qty: number) {
    const productForm = document.querySelector('form.ProductForm') as HTMLFormElement;

    if (!productForm) {
      log.error('Could not find product form!');
      return;
    }

    const subscriptionOptions = productForm.querySelectorAll(
      '.appstle_subscription_wrapper_option',
    ) as NodeListOf<HTMLElement>;

    subscriptionOptions.forEach((option) => {
      const moneyWrapper = option.querySelector(
        '.appstle_subscription_amount.transcy-money',
      ) as HTMLElement;

      let price = moneyWrapper.querySelector('.money') as HTMLElement;

      if (!price) {
        price = moneyWrapper;
      }

      const priceValue = parseFloat(price?.textContent?.replace('$', '').replace(',', '') || '0');

      setTimeout(() => {
        if (option.querySelector('.updated-price')) {
          option.querySelector('.updated-price')?.remove();
        }

        const salePrice = option.querySelector(
          '.appstle_subscription_compare_amount.transcy-money',
        ) as HTMLElement;
        const salePriceValue =
          salePrice && salePrice.childNodes.length > 0
            ? parseFloat(salePrice?.textContent?.replace('$', '').replace(',', '') || '0')
            : null;

        const newPrice = document.createElement('div');
        newPrice.classList.add('updated-price');
        newPrice.innerHTML = `<span class="total">$${(priceValue * qty).toFixed(2)} ${salePriceValue ? `<span class="sale-price">$${(salePriceValue * qty).toFixed(2)}</span>` : ''}</span>
      ${qty > 1 ? `<span class="per-unit">$${priceValue.toFixed(2)} each</span>` : ''}`;

        moneyWrapper.after(newPrice);
      }, 100);
    });
  }

  const packOptions = new PackOptions({
    wrapper: document.querySelector('[data-bundles-wrapper]') as HTMLElement,
    onInit: (instance: PackOptions) => {
      const initialMultiple = instance.getActivePackMultiple();
      log.debug(`Setting initial multiple to ${initialMultiple}`);
      updateATCQty(initialMultiple);

      const activePacks = document.querySelectorAll(
        '.pack-options .ProductForm__OptionWrapper:not([disabled])',
      );

      if (activePacks.length === 0) {
        instance.hidePackOptions();
        return;
      }

      const currentVariant: number = parseInt(window.location.search.split('variant=')[1] || '0');

      const newVariantEligible = checkEligibility(currentVariant);

      if (!newVariantEligible) {
        instance.hidePackOptions();
        instance.setActivePackMultiple(1);
      } else {
        instance.showPackOptions();
      }

      defer(() => {
        updateSubscriptionOptions(initialMultiple);
      }, '.appstle_subscription_wrapper_option');
    },
    onSelect: (instance: PackOptions, multiple: number) => {
      const productForm = document.querySelector('form.ProductForm') as HTMLFormElement;

      if (!productForm) {
        log.error('Could not find product form!');
        return;
      }

      const qtySelector = productForm.querySelector("input[name='quantity']") as HTMLInputElement;

      if (!qtySelector) {
        log.error('Could not find quantity selector!');
        return;
      }

      const finalQty = multiple * parseInt(qtySelector.value);

      updateATCQty(finalQty);
      updateSubscriptionOptions(finalQty);
    },
  });

  packOptions.bindEvents();

  defer(() => {
    document.querySelector('.Product')!.addEventListener('variant:changed', function (e) {
      log.debug(e);
      setTimeout(() => {
        const activeBundleTrigger = document.querySelector(
          '.ProductForm__OptionWrapper.active [data-bundle-trigger]',
        ) as HTMLElement;

        if (activeBundleTrigger) {
          activeBundleTrigger.click();
        }

        const newVariantEligible = checkEligibility((e as VariantChangedEvent).detail.variant.id);

        if (!newVariantEligible) {
          packOptions.hidePackOptions();
          packOptions.setActivePackMultiple(1);
        } else {
          packOptions.showPackOptions();
        }
      }, 50);
    });
  }, '.Product');
});
